import styled, { css } from 'styled-components';
import { Tag } from 'antd';
import { TagTypes } from '.';

interface CustomTagContainerProps {
  color?: string;
  type: TagTypes;
}

export const CustomTagContainer = styled(Tag)<CustomTagContainerProps>`
  font-weight: bold;

  ${({ type, color, theme }) => {
    const isDefault = type === 'default';

    if (isDefault) {
      return css`
        background: transparent !important;
        border: 1px solid ${color ?? theme?.colors?.border};
        color: ${color ?? theme?.colors?.text1};

        .anticon svg {
          color: ${color ?? theme?.colors?.text1};
        }
      `;
    }
    return css`
      background: ${color ?? theme?.colors?.content};
      border: 1px solid ${color ?? theme?.colors?.border};
      color: ${color ? theme?.colors?.white : theme?.colors?.text1};

      .anticon svg {
        color: ${color ? theme?.colors?.white : theme?.colors?.text1};
      }
    `;
  }}
`;
